<template>
	<div class="contentPage">
		<main-table
				v-if="shortPaymentsList && !isRow"
				flag="shortPayments"
				pageTitle="Short payments"
				:headers="headers"
				:listItems="shortPaymentsList"
				:filtersList="shortPaymentsFilterList"
				:isCreate="false"
				:uniqId="uniqId"
				:updateRefreshFilters="refreshFilters"
				infoText="Age (days) info"
				@updateInfo="onInfo"
				@updateClickButton="onClickButton"
				@updateEdit="onEdit"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				@updateChangeSort="onFilter"
				@updateExport="onExport"
				@updateSettings="onSettingsOpen"
				isInfo
				isExport
				isSettings
		></main-table>
		<view-load
				v-if="dataVal && isRow"
				@updateCloseViewLoad="onCloseViewLoad"
				@updateClose="onClose"
				@actionDelete="onDelete"
				:dataVal="dataVal"
				:permissions="permissions"
		></view-load>
		<actions-popup
				v-if="isDialog"
				:isDialog="isDialog"
				:dataActions="dataActions"
				:shortPaymentsActions="getShortPaymentsActions"
				:dataSort="dataSort"
				:permissions="permissions"
				@updateClose="onClose"
				@actionDelete="onDelete"
		></actions-popup>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>

		<dialog-table
				v-if="isInformationPopup"
				:list="getShortPaymentsInfoModalContent"
				title="Age (days) info"
				:headers="getShortPaymentsInfoModalHeader"
				:flag="ff"
				@updateClose="onCloseInformationPopup"
				width="500px"
				:is-last-row="false"
		>
			<template #subTitle>
				<div class="isInformationPopup text_info">( only status - Waiting for payment )</div>
			</template>
		</dialog-table>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ActionsPopup = () => import('@/components/Accounting/ShortPayments/ActionsPopup/ActionsPopup');
const ViewLoad = () => import('@/components/Accounting/ShortPayments/Viewload/ViewLoad');
const TableSettings = () => import("@/shared/TableSettings/TableSettings");

// constants
import { downloadDoc } from "@/helper/getDownloadDoc";
import getUniqId from "@/helper/getUniqId";
import { getActiveSetting } from "@/helper/getActiveSetting";
import DialogTable from "@/shared/DialogTable/DialogTable.vue";
import { shortPaymentsInfoModalContent, shortPaymentsInfoModalHeader } from "@/constants/defaultHeader";
import { PAGE } from "@/constants/constants";
export default {
	name: "ShortPayments",
	components: {
		DialogTable,
		ActionsPopup,
		ViewLoad,
		TableSettings
	},
	computed: {
		...mapGetters([
			'shortPaymentsList',
			'shortPaymentsFilterList',
			'shortPaymentsActions',
			'permissions',
			'shortPaymentsExportLink',
			'shortPaymentsSettingsDefault',
			'shortPaymentsSettings',
			'shortPaymentsHeaders',
		]),

		getShortPaymentsInfoModalContent() {
			return shortPaymentsInfoModalContent;
		},
		getShortPaymentsInfoModalHeader() {
			return shortPaymentsInfoModalHeader;
		},
		headers() {
			return this.shortPaymentsHeaders;
		},
		getItems() {
			return this.shortPaymentsList;
		},
		getShortPaymentsActions() {
			return this.shortPaymentsActions || [];
		},
	},
	watch: {
		shortPaymentsExportLink(value, oldValue) {
			if (value !== oldValue) {
				downloadDoc(value);
			}
		},
	},
	data: () => ({
		ff: PAGE.SHORT_PAYMENTS,
		refreshFilters: false,
		dataSort: {},
		isDialog: false,
		dataActions: null,
		isRow: false,
		dataVal: null,
		isInformationPopup: false,
		isTableSettingsDrawer: false,
		uniqId: null,
	}),
	methods: {
		...mapActions([
			'onShortPaymentsFilter',
			'onShortPaymentsList',
			'onShortPaymentsActions',
			'onDeleteShortPaymentsActions',
			'getShortPaymentsExport',
			'onShortPaymentsSettingsReset',
			'onShortPaymentsSettingsSave',
			'onShortPaymentsSettingsAll',
		]),
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.onShortPaymentsSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},
		async onSettingsSave() {
			await this.onShortPaymentsSettingsSave();
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.onShortPaymentsSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
		async onExport(filters) {
			const value = filters;
			value['setting'] = getActiveSetting(this.settings);

			await this.getShortPaymentsExport(value);
		},

		onInfo() {
			this.isInformationPopup = true;
		},
		onCloseInformationPopup() {
			this.isInformationPopup = false;
		},
		async onFilter(info) {
			await this.onShortPaymentsFilter(info.filterModList);
		},
		async onClickButton({ key, item }) {
			if (key === "actions") {
				const { load_id, amount_factoring, status } = item;
				const values = { id: load_id, amount_factoring, status };

				await this.onShortPaymentsActions(values);
				this.isDialog = true;
				this.dataActions = values;
			}
		},
		async onEdit(onValue) {
			const { load_id, ...obj } = onValue.line;
			const values = { id: load_id, ...obj };
			if (this.permissions['10'] || this.permissions['9']) {
				this.$emit('updateEditRow', values);
				await this.onShortPaymentsActions(values);
				this.isRow = true;
				this.dataVal = values;
				await this.onShortPaymentsList();
			}
		},

		onSort(values) {
			this.dataSort = values;
		},
		async onActions(values) {
			await this.onShortPaymentsActions(values);
			this.isDialog = true;
			this.dataActions = values;
		},
		onClose() {
			this.isDialog = false;
			this.dataActions = null;
		},
		async onDelete(value) {
			await this.onDeleteShortPaymentsActions(value);
			await this.onShortPaymentsList();
		},
		async onEditRow(values) {
			await this.onShortPaymentsActions(values);
			this.isRow = true;
			this.dataVal = values;
			await this.onShortPaymentsList();
		},
		onCloseViewLoad() {
			this.isRow = false;
		}
	},
	async mounted() {
		await this.onShortPaymentsList();
	}
};
</script>

<style lang="scss" scoped>
@import "./shortPayments";

.isInformationPopup.text_info {
	font-size: 14px;
	color: #c2c2c2;
}
</style>
